module.exports = __webpack_public_path__ + "static/media/player_back.22d500b2.png";